import React, { useState } from 'react';
import { useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useCustomerAuth } from '../context/CustomerAuthContext';

const SetPasswordPage = () => {
  const { customer, changePassword } = useCustomerAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [newPw, setNewPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPw !== confirm) { setError('Passwords do not match'); return; }
    if (newPw.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      await changePassword(null, newPw);
      navigate('/portal/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to set password');
    } finally {
      setLoading(false);
    }
  };

  if (params.get('token')) return <Navigate replace to={`/portal/reset-password?mode=setup&token=${encodeURIComponent(params.get('token'))}`} />;
  if (!customer) return <Navigate replace to="/portal/login?mode=setup" />;
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1B3A5C] to-[#0f2640] flex items-center justify-center px-4" data-testid="set-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="w-16 h-16 rounded-full bg-[#F5A623]/20 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-[#F5A623]" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Set Your Password</h1>
          <p className="text-white/50 text-sm">Choose a secure password for your account</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4 text-sm">{error}</div>
          )}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">New Password</label>
              <input
                type="password" value={newPw} onChange={e => setNewPw(e.target.value)}
                placeholder="Minimum 8 characters" required minLength={8}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#4A90A4] focus:border-transparent outline-none text-gray-900"
                data-testid="new-password"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Confirm Password</label>
              <input
                type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                placeholder="Re-enter your password" required
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#4A90A4] focus:border-transparent outline-none text-gray-900"
                data-testid="confirm-password"
              />
            </div>
            <button type="submit" disabled={loading}
              className="w-full py-3.5 bg-[#F5A623] text-white font-bold rounded-xl hover:brightness-110 transition-all disabled:opacity-50">
              {loading ? 'Setting password...' : 'Set Password & Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SetPasswordPage;
